import { useEffect, useState } from 'react';
import { getMe } from 'services/users.service';
import { getSession } from 'services/auth.service';
import { hasPermissions } from 'modules/user-has-permission/user-has-permission';
import getRedirectPath from 'modules/get-redirect-path/get-redirect-path';
import { Card, Container, Dimmer, Loader } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { useAlert } from 'context/AlertProvider';

export default function LoginCallbackPage() {
  const alert = useAlert();
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(async () => {
      try {
        const { idToken } = await getSession();
        await getMe();
        const userHasPermissions = hasPermissions(idToken.payload.permissions);
        if (userHasPermissions) {
          history.push(getRedirectPath());
        } else {
          alert.current.error(
            'El usuario no tiene permisos para acceder a la aplicación',
          );
          throw new Error();
        }
      } catch (error) {
        setLoading(false);
        history.push('/login');
      }
    }, 3000);
  }, [history, alert]);

  return (
    <Container fluid>
      <Card fluid>
        <Dimmer.Dimmable>
          <Dimmer active={loading} inverted>
            <Loader style={{ marginTop: 100 }}>Redirigiendo…</Loader>
          </Dimmer>
        </Dimmer.Dimmable>
      </Card>
    </Container>
  );
}
